export default "__VITE_ASSET__123fce5a__"